export function formatDemoPackItemLabel(
  label: string,
  requirementCode?: string | null,
): string {
  const trimmed = label.trim();
  if (!requirementCode?.trim()) return trimmed;
  return `${requirementCode.trim()} · ${trimmed}`;
}
